import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, MenuItem, Select, TextField, Typography } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';
import { isHomePracticeTitle, templateDisplayTitle } from './homeworkPracticeTemplate';

export default function ConsultationReportDialog({ onClose, onGenerate, onSelectTemplate, onUploadTemplate, open, inline = false, readOnly = false, canGenerate = true, isGenerating, isRefiningTranscript = false, selectedTemplate, templates, sourceLabel, reportDate, onReportDateChange }) {
  if (!open) return null;
  const homework = isHomePracticeTitle(selectedTemplate?.title);
  const action = 'Generate';
  const fields = <>
        <Typography variant="body2" sx={{ color: '#667085', mb: 1.5 }}>{sourceLabel || 'Current consultation'}</Typography>
        <TextField size="small" type="date" label="Report date" value={reportDate || ''} onChange={event => onReportDateChange?.(event.target.value)}
          InputLabelProps={{ shrink: true }} inputProps={{ 'aria-label': 'Report date' }} sx={{ mb: 1.5, width: 180 }} />
        <Typography variant="body2" sx={{ color: '#344054', fontWeight: 600, mb: 0.75 }}>Template</Typography>
        <Select
          fullWidth
          size="small"
          value={selectedTemplate?.id || ''}
          displayEmpty
          onChange={event => onSelectTemplate(event.target.value)}
        >
          <MenuItem disabled value=""><em>{templates.length ? 'Select template' : 'No templates available'}</em></MenuItem>
          {templates.map(template => <MenuItem key={template.id} value={template.id}>{templateDisplayTitle(template.title)}</MenuItem>)}
        </Select>
        <Button component="label" size="small" startIcon={<UploadFileIcon />} sx={{ mt: 1, textTransform: 'none' }}>
          Upload template
          <input type="file" hidden disabled={readOnly} accept=".txt,.docx,.pdf" onChange={onUploadTemplate} />
        </Button>
        <Typography variant="caption" sx={{ display: 'block', mt: 2, color: '#667085' }}>
          Your sources remain available if you cancel.
        </Typography>
  </>;
  const actions = <>
        <Button onClick={onClose} disabled={isGenerating} sx={{ textTransform: 'none' }}>Cancel</Button>
        <Button
          variant="contained"
          onClick={onGenerate}
          disabled={!selectedTemplate || !canGenerate || isGenerating}
          startIcon={isGenerating ? <CircularProgress size={14} color="inherit" /> : <AutoAwesomeIcon />}
          sx={{ backgroundColor: '#7C3AED', textTransform: 'none', '&:hover': { backgroundColor: '#6D28D9' } }}
        >
          {isRefiningTranscript ? 'Refining transcript…' : isGenerating ? 'Generating…' : action}
        </Button>
  </>;
  if (inline) return <Box aria-label="Report setup" sx={{ p: 2, borderBottom: '1px solid #E5E7EB' }}>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
      <Typography variant="h6" sx={{ fontWeight: 700 }}>{homework ? 'Home practice' : 'Generate'}</Typography>
      <IconButton aria-label="Close report setup" size="small" onClick={onClose} disabled={isGenerating}><CloseIcon /></IconButton>
    </Box>
    {fields}
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 2, flexWrap: 'wrap' }}>{actions}</Box>
  </Box>;
  return (
    <Dialog open={open} onClose={isGenerating ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontWeight: 700 }}>{homework ? 'Home practice' : 'Generate'}</DialogTitle>
      <DialogContent>{fields}</DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>{actions}</DialogActions>
    </Dialog>
  );
}
